/* eslint-disable camelcase */
import { useQuery } from '@tanstack/react-query';
import ms from 'ms';
import { stringify } from 'qs';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';
import { axiosInstance } from 'hb-react/shared/utils/axios';

export const useQueryTopicEvents = ({
  key = [],
  enabled = true,
  params: { per_page = 12 } = {},
}: {
  enabled?: boolean;
  key?: Array<string>;
  params?: { per_page?: number };
} = {}) => {
  const { currentUser } = useDefaultAppContexts();
  const topicContext = useTopicContext();

  const { data: { events = [] } = {}, isLoading } = useQuery({
    queryKey: [
      'topic',
      topicContext.topicId,
      'events',
      'per_page',
      per_page,
      ...key,
    ],
    queryFn: () =>
      axiosInstance
        .get(
          currentUser
            ? Routes.topics_topic_events_path(topicContext.topicId, {
                format: 'json',
              })
            : dynamicTopicResourcePath(
                Routes.topic_publicoffice_topics_events_path(
                  topicContext.topicId,
                  {
                    format: 'json',
                  },
                ),
                topicContext,
              ),
          {
            params: {
              per_page,
              query: {
                gte_start_date: 'now',
                sort_by: 'start_date',
                order: 'asc',
              },
            },
            paramsSerializer: (params) =>
              stringify(params, {
                arrayFormat: 'brackets',
                encode: false,
              }),
          },
        )
        .then(({ data }) => data),
    enabled,
    staleTime: ms('5m'),
  });

  return {
    events,
    isLoading,
  };
};
